import { CommanderFormProps, useDialogFormControls } from '../../dialogForm';
import { UseSteppedFormControlsParams } from '../types';
// import { createSteppedFormSubmitHandler } from './createSteppedFormSubmitHandler';

export const useSteppedDialogFormControls = <S extends string, I extends object, O extends object = I>({
    steps,
    stepHandlers,
    stepResolvers,
    currentStep,
    setCurrentStep,
    onSubmitting,
    onSuccess,
    onSubmitted,
    onSubmit,
    ...other
}: UseSteppedFormControlsParams<S, I, O> & CommanderFormProps) => {
    const { renderFormContent, ...formControls } = useDialogFormControls<I, O>({
        ...other,
        resolver: stepResolvers?.[currentStep],
        onSubmit: async (formValues, extra) => {
            const currentStepIndex = steps.indexOf(currentStep);
            if (currentStepIndex < steps.length - 1) {
                if (stepHandlers?.[currentStep]) {
                    onSubmitting?.();
                    try {
                        await stepHandlers[currentStep](formValues, { setCurrentStep });
                    } finally {
                        onSubmitted?.();
                    }
                } else {
                    setCurrentStep(steps[currentStepIndex + 1]);
                }
            } else {
                onSubmitting?.();
                try {
                    await onSubmit(formValues, extra);
                    onSuccess?.();
                } finally {
                    onSubmitted?.();
                }
            }
        },
    });

    return {
        ...formControls,
        renderFormContent: (matchStep: (step: S) => Parameters<typeof renderFormContent>[0]) =>
            renderFormContent(matchStep(currentStep)),
    };
};
